import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GenerateHuaweiRemoteAnalysisRequest = (fileLocation, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}CM/GenerateHuaweiRemoteAnalysis`,
	params: { fileLocation, userId }
});
